import { useState, useCallback } from "react";
import { Header, Sidebar, Disclaimer, DorkReference, QueryChain } from "./components/index";
import Generator from "./components/Generator";
import "./styles.css";

export default function App() {
  const [activeTab, setActiveTab] = useState("generator");
  const [allDorks, setAllDorks] = useState([]);
  const [chainQueries, setChainQueries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [presetQuery, setPresetQuery] = useState("");

  const handleDorksGenerated = useCallback((dorks) => {
    setAllDorks(dorks);
  }, []);

  const addToChain = useCallback((query) => {
    setChainQueries((prev) =>
      prev.includes(query) ? prev : [...prev, query]
    );
  }, []);

  const removeFromChain = useCallback((index) => {
    setChainQueries((prev) => prev.filter((_, i) => i !== index));
  }, []);

  return (
    <div className="app">
      <Header dorkCount={allDorks.length} />
      <Disclaimer />
      <nav className="tabs">
        {["generator", "learn", "chain"].map((t) => (
          <button
            key={t}
            className={`tab ${activeTab === t ? "active" : ""}`}
            onClick={() => setActiveTab(t)}
          >
            {"// "}
            {t === "generator"
              ? "Generator"
              : t === "learn"
              ? "Dork Reference"
              : `Query Chain (${chainQueries.length})`}
          </button>
        ))}
      </nav>
      <div className="main">
        <Sidebar onPresetSelect={setPresetQuery} setActiveTab={setActiveTab} />
        <div className="content">
          {activeTab === "generator" && (
            <Generator
              onDorksGenerated={handleDorksGenerated}
              onAddToChain={addToChain}
              presetQuery={presetQuery}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          )}
          {activeTab === "learn" && <DorkReference />}
          {activeTab === "chain" && (
            <QueryChain
              queries={chainQueries}
              onRemove={removeFromChain}
              onClear={() => setChainQueries([])}
            />
          )}
        </div>
      </div>
    </div>
  );
}
